<ng-container *ngIf="isAudibel; else starkeyBanner">
  <div class="audibelBanner">Smartphone compatibility</div>
</ng-container>
<ng-template #starkeyBanner>
  <div class="banner">Smartphone compatibility</div>
</ng-template>
